<div class="container">
  <div class="row mb-1">
    <div class="col-md-12 text-end">
      <button (click)="exportToExcel()"
      class="btn-shadow d-inline-flex align-items-center btn btn-success" 
      style="margin-right:5px ;">
        Export To Excel
      </button>
      <button
        (click)="back()"
        class="btn-shadow d-inline-flex align-items-center btn btn-success"
      >
        <i class="fa fa-arrow-circle-left mr-5"></i> Back
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-header font-weight-B fs-1r">
          <div>Package Details</div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-2 m-auto vehicle_img">
              <div *ngIf="packageimageUrl">
                <img src="{{ packageimageUrl }}" alt="" />
              </div>
            </div>
            <div class="col-md-2 m-auto vehicle_img">
              <div *ngIf="vehicleimageUrl">
                <img src="{{ vehicleimageUrl }}" alt="" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-3">
              <label for="">ID </label>
              <input
                type="text"
                [ngModel]="packageData?._id"
                class="form-control"
                placeholder="ID"
                [disabled]="true"
              />
            </div>

            <div class="col-md-3">
              <label for="">User ID </label>
              <input
                type="text"
                [ngModel]="packageData?.userId"
                class="form-control"
                placeholder=" User ID"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Pick Up Pin </label>
              <input
                type="text"
                [ngModel]="packageData?.pickupPin"
                class="form-control"
                placeholder=" User ID"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Package ID. </label>
              <input
                type="text"
                [ngModel]="packageData?.packageID"
                class="form-control"
                placeholder="Package ID"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">Sender Name </label>
              <input
                type="text"
                [ngModel]="packageData?.senderName"
                class="form-control"
                placeholder="Sender name"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Receiver Name </label>
              <input
                type="text"
                [ngModel]="packageData?.receiverName"
                class="form-control"
                placeholder="Receiver name"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Sender Mobile No. </label>
              <input
                type="text"
                [ngModel]="packageData?.senderMobile"
                class="form-control"
                placeholder="Sender mobile no."
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Receiver Mobile No. </label>
              <input
                type="text"
                [ngModel]="packageData?.receiverMobile"
                class="form-control"
                placeholder="Receiver mobile no."
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Special Instructions </label>
              <input
                type="text"
                [ngModel]="packageData?.specialInstructions"
                class="form-control"
                placeholder="Special instructions"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">Sender Email </label>
              <input
                type="email"
                [ngModel]="packageData?.senderEmail"
                class="form-control"
                placeholder="Sender email"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Receiver Email </label>
              <input
                type="email"
                [ngModel]="packageData?.receiverEmail"
                class="form-control"
                placeholder="Receiver email"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Sender Address </label>
              <input
                type="text"
                [ngModel]="packageData?.fromAddress"
                placeholder="Sender address"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Receiver Address </label>
              <input
                type="text"
                [ngModel]="packageData?.toAddress"
                placeholder="Receiver address"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">No. of Packages </label>
              <input
                type="text"
                [ngModel]="packageData?.noOfPackages"
                class="form-control"
                placeholder="Numbers of packages"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">Sender Latitude </label>
              <input
                type="text"
                [ngModel]="packageData?.fromLatitude"
                placeholder="Sender Latitude"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Receiver Latitude </label>
              <input
                type="text"
                [ngModel]="packageData?.toLatitude"
                placeholder="Receiver Latitude"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Sender Longtitude </label>
              <input
                type="text"
                [ngModel]="packageData?.fromLongitude"
                placeholder="Sender Longtitude"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Receiver Longtitude </label>
              <input
                type="text"
                [ngModel]="packageData?.toLongitude"
                placeholder="Receiver Longtitude"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Distance (KM) </label>
              <input
                type="text"
                [ngModel]="packageData?.distance"
                class="form-control"
                placeholder="Distance"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">Package Diamentions</label>
              <input
                type="text"
                [ngModel]="packageData?.goodsDimension"
                placeholder="Diamentions"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Package Description </label>
              <input
                type="text"
                [ngModel]="packageData?.goodsDescription"
                class="form-control"
                placeholder="Package description"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Package Weight (KG) </label>
              <input
                type="text"
                [ngModel]="packageData?.goodsWeightKg"
                class="form-control"
                placeholder="Package weight"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for=""> Delivery Price </label>
              <input
                type="text"
                [ngModel]="(packageData?.tripFareTotalAmt | number: '1.2-2')"
                class="form-control"
                placeholder="Price package delivery"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Driver Tip </label>
              <input
                type="text"
                [ngModel]="packageData?.driverTip"
                class="form-control"
                placeholder="Driver tip"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2">
            <div class="col-md-1"></div>
            <div class="col-md-4">
              <label for="">Vehicle ID </label>
              <input
                type="text"
                [ngModel]="packageData?.vehicleId"
                placeholder="Vehicle ID"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Helper Requirement</label>
              <input
                type="text"
                [ngModel]="packageData?.helperCount"
                class="form-control"
                placeholder="Vehicle Name"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Vehicle type</label>
              <input
                type="text"
                [ngModel]="packageData?.vehicleType"
                class="form-control"
                placeholder="Vehicle Name"
                [disabled]="true"
              />
            </div>
           
            <div class="col-md-2">
              <label for="">Package status</label>
              <select
                class="form-control"
                disabled
                name=""
                id=""
                [ngModel]="packageData?.status"
              >
                <option value="0">Package is generated</option>
                <option value="1">Accepted by driver</option>
                <option value="2">Trip is Started</option>
                <option value="3">Trip is completed</option>
                <option value="4">cancelled by user</option>
                <option value="5">cancelled by driver</option>
              </select>
            </div>

            <div class="col-md-1"></div>
          </div>

          <div class="row mt-3">
            <div class="col-md-1"></div>
            <!-- <div class="col-md-2 ">
            <div>
              <a (click)="onNavigate('PACKAGE' ,  packageData?.photos)" class="btn-shadow  d-inline-flex align-items-center btn btn-success">
                <i class="fa fa-eye mr-5"></i>  View Image  </a>
            </div> 
          </div> -->
            <div class="col-md-3">
              <div>
                <a
                  (click)="onNavigate('VEHICLE', packageData?.vehicleImage)"
                  class="btn-shadow d-inline-flex align-items-center btn btn-success"
                >
                  <i class="fa fa-eye mr-5"></i> View Vehicle Image
                </a>
              </div>
            </div>
            <div class="col-md-3">
              <!-- <div>
                <a
                  *ngIf="
                    (packageData?.status == 0 || packageData?.status == 5) &&
                    ((packageData?.paymentDetails?.paymentMethod == 'cash' &&
                      packageData?.paymentDetails?.status == 0) ||
                      (packageData?.paymentDetails?.paymentMethod == 'online' &&
                        packageData?.paymentDetails?.status == 1)) &&
                        packageAccepted == false
                  "
                  (click)="acceptPackage(); openModal()"
                  class="btn-shadow d-inline-flex align-items-center btn btn-success"
                >
                  Regenerate Request
                </a>
              </div> -->
             
            </div>
           <div class="col-md-1"></div>
          </div>
          <!-- Stops Commented -->
          <!-- <div class="row mt-3">
            <div class="col-md-1"></div>
            <div class="col-md-10 text-center">
              <h5 class="font-weight-B">STOPS</h5>
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">Receiver Name </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop1?.receiverName"
                placeholder="Receiver Name "
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Receiver Mobile No. </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop1?.receiverPhoneNo"
                class="form-control"
                placeholder="Receiver Mobile No."
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for=""> Address </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop1?.address"
                class="form-control"
                placeholder="Address"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Latitide </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop1?.latitude"
                class="form-control"
                placeholder="Latitide"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Longtitude </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop1?.longitude"
                class="form-control"
                placeholder="Longtitude"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">Receiver Name </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop2?.receiverName"
                placeholder="Receiver Name"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Receiver Mobile No. </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop2?.receiverPhoneNo"
                class="form-control"
                placeholder="Receiver Mobile No."
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for=""> Address </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop2?.address"
                class="form-control"
                placeholder="Address"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Latitide </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop2?.latitude"
                class="form-control"
                placeholder="Latitide"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Longtitude </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop2?.longitude"
                class="form-control"
                placeholder="Longtitude"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">Receiver Name </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop3?.receiverName"
                placeholder="Receiver Name"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Receiver Mobile No. </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop3?.receiverPhoneNo"
                placeholder="Receiver Mobile No."
                class="form-control"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for=""> Address </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop3?.address"
                placeholder="Address"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Latitide </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop3?.latitude"
                placeholder="Latitide"
                class="form-control"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Longtitude </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop3?.longitude"
                placeholder="Longtitude"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row mt-2">
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <label for="">Receiver Name </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop4?.receiverName"
                placeholder="Receiver Name"
                class="form-control"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Receiver Mobile No. </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop4?.receiverPhoneNo"
                class="form-control"
                placeholder="Receiver Mobile No."
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for=""> Address </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop4?.address"
                class="form-control"
                placeholder="Address"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Latitide </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop4?.latitude"
                class="form-control"
                placeholder="Latitide"
                [disabled]="true"
              />
            </div>

            <div class="col-md-2">
              <label for="">Longtitude </label>
              <input
                type="text"
                [ngModel]="packageData?.stops?.stop4?.longitude"
                class="form-control"
                placeholder="Longtitude"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div> -->

          <div class="row mt-3">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <div class="table-responsive">
                <table
                  style="
                    border: 1px solid black;
                    border-collapse: collapse;
                    width: 100%;
                  "
                >
                  <thead>
                    <th class="text-end">Billing Details</th>
                  </thead>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Trip Fare
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.tripFareWithoutGST">
                        {{ packageData?.tripFareWithoutGST | number : "2.2-2" }}
                      </span>
                      <span *ngIf="!packageData?.tripFareWithoutGST">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      GST on Trip Fare
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.tripFareGST">
                        {{ packageData?.tripFareGST | number : "2.2-2" }}
                      </span>
                      <span *ngIf="!packageData?.tripFareGST">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Labour Cost
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.billDetails?.labourCost">
                        {{
                          packageData?.billDetails?.labourCost
                            | number : "2.2-2"
                        }}
                      </span>
                      <span *ngIf="!packageData?.billDetails?.labourCost">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      GST on Labour Cost
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.helperGST">
                        {{ packageData?.helperGST | number : "2.2-2" }}
                      </span>
                      <span *ngIf="!packageData?.helperGST">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Commission
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.commissionTotalAmt">
                        {{ packageData?.commissionTotalAmt | number : "2.2-2" }}
                      </span>
                      <span *ngIf="!packageData?.commissionTotalAmt">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      GST on Commission
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.commissionGST">
                        {{ packageData?.commissionGST | number : "2.2-2" }}
                      </span>
                      <span *ngIf="!packageData?.commissionGST">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Convenience Fee
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.convenienceWithoutGST">
                        {{
                          packageData?.convenienceWithoutGST | number : "2.2-2"
                        }}
                      </span>
                      <span *ngIf="!packageData?.convenienceWithoutGST">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      GST on Convenience Fee
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.convenienceGST">
                        {{ packageData?.convenienceGST | number : "2.2-2" }}
                      </span>
                      <span *ngIf="!packageData?.convenienceGST">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Coupon Discount
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.billDetails?.couponDiscount">
                        -{{
                          packageData?.billDetails?.couponDiscount
                            | number : "2.2-2"
                        }}
                      </span>
                      <span *ngIf="!packageData?.billDetails?.couponDiscount">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Net Fare
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.billDetails?.netFare">
                        {{
                          packageData?.billDetails?.netFare | number : "2.2-2"
                        }}</span
                      >
                      <span *ngIf="!packageData?.billDetails?.netFare">
                        {{ 0 | number : "2.2-2" }}</span
                      >
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Total Amount
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.tripFareTotalAmt">
                        {{ packageData?.tripFareTotalAmt | number : "2.2-2" }}
                      </span>
                      <span *ngIf="!packageData?.tripFareTotalAmt">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="col-md-5">
              <div class="table-responsive">
                <table
                  style="
                    border: 1px solid black;
                    border-collapse: collapse;
                    width: 100%;
                  "
                >
                  <thead>
                    <th class="text-end">Payment Details</th>
                  </thead>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Payment ID
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{
                        packageData?.paymentDetails?.paymentId
                          ? packageData?.paymentDetails?.paymentId
                          : "Not Found"
                      }}
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Payment Method
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{
                        packageData?.paymentDetails?.paymentMethod
                          ? packageData?.paymentDetails?.paymentMethod
                          : "Not Found"
                      }}
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Total Amount
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.paymentDetails?.totalAmount">
                        {{
                          packageData?.paymentDetails?.totalAmount
                            | number : "2.2-2"
                        }}
                      </span>
                      <span *ngIf="!packageData?.paymentDetails?.totalAmount">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Wallet Amount
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span *ngIf="packageData?.paymentDetails?.walletAmount">
                        {{
                          packageData?.paymentDetails?.walletAmount
                            | number : "2.2-2"
                        }}
                      </span>
                      <span *ngIf="!packageData?.paymentDetails?.walletAmount">
                        {{ 0 | number : "2.2-2" }}
                      </span>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Status
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <span *ngIf="!packageData?.paymentDetails?.status">
                        Not Found</span
                      >
                      <span *ngIf="packageData?.paymentDetails?.status == 1">
                        Done
                      </span>
                      <span *ngIf="packageData?.paymentDetails?.status == 0">
                        Pending
                      </span>
                    </td>
                  </tr>
                  <!-- </thead> -->
                </table>
              </div>
              <!-- [hidden]="packageData?.status!==3" -->
              <div class="table-responsive mt-3">
                <table
                  style="
                    border: 1px solid black;
                    border-collapse: collapse;
                    width: 100%;
                  "
                >
                  <thead>
                    <th class="text-end">Payment To Driver</th>
                  </thead>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Driver ID
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ packageData?.driverId }}
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Driver Name
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ packageData?.driverName }}
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Total Amount
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      <i class="fa fa-inr" aria-hidden="true"></i>
                      <span>
                        {{ driverAmount }}</span
                      >
                    </td>
                  </tr>
                  <tr class="text-center">
                    <th
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      Mobile Number
                    </th>
                    <td
                      style="border: 1px solid black; border-collapse: collapse"
                    >
                      {{ packageData?.driverMobile }}
                    </td>
                  </tr>
                  <!-- </thead> -->
                </table>
              </div>
            </div>

            <!-- <button (click)="openModal()">Open Modal</button> -->

            <div class="col-md-1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" [ngClass]="{ show: isModalOpen }" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- <span class="close" (click)="closeModal()">&times;</span> -->

    <!-- vehicle running -->
     
      <div *ngIf="vehicleRunning" >
      <h3>Please Wait!</h3>
      <p>Driver Will Accept request very soon...</p>

      <img
        src="../../assets/images/vehicle_with-location.gif"
        alt="Running GIF"
        class="modal-gif"
      />
      </div>
      
      <!-- time out -->
      <!-- <div *ngIf="timeout" class="center-container">
        <img src="../../assets/images/eos_icons_timeout.png" alt="Timeout Icon">
        <h3 class="timeout">Time Out</h3>
        <p class="para">Click on OK to re-send the request to all drivers</p>
        <button class="button btn-success" (click)="acceptPackage()" >OK</button>
      </div> -->

      <!-- trip accept -->
       <div *ngIf="packageAccepted" class="center-container">
        <img src="../../assets/images/correct.png" alt="Timeout Icon">
        <h3 class="timeout">Trip is accepted</h3>
        <p class="para">Click on OK to Track Order</p>
        <button class="button btn-success" (click)="routeTrackPackage()" >OK</button>
      </div>
  </div>
</div>
